import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Card, CardBody, Row, Col, CardHeader, Form } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Breadcrumbs, H3, H4 } from '../../AbstractElements';
import { Filter, Search, Status } from '../../Constant';
import Button from '../Common/Elements/Button';
import { getAttendance, getAttendanceRole, getUsers, getUsersRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { toast } from 'react-toastify';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';

const AttendanceLog = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [staffOptions, setStaffOptions] = useState([]);

    // Filter states
    const [selectedEmployee, setSelectedEmployee] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;

    // Pagination states
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const authState = useSelector((state) => state.auth);

    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            search: params.get('search') || '',
            employee_id: params.get('employee_id') || '',
            status: params.get('status') || '',
        }
    });

    // Top stat cards data
    const stats = [
        { title: 'Total sessions this month', value: '2,418', valueColor: '#059669' },
        { title: 'Avg daily hours', value: '8.4h', valueColor: '#111827' },
        { title: 'Total overtime this month', value: '312h', valueColor: '#2563eb' },
        { title: 'Late arrivals this month', value: '47', valueColor: '#ea580c' },
        { title: 'Missing punches', value: '18', valueColor: '#dc2626' },
    ];

    // Dummy table data matching the image
    // const data = [
    //     { id: 1, initials: 'AM', avatarBg: '#0f766e', name: 'Arjun Menon', date: '15 May', in: '09:04', inColor: '#059669', out: '—', breakTime: '30m', netHours: '6h 37m', otHours: '0h', location: 'Verified', status: 'Present', statusClass: 'badge-approved' },
    //     { id: 2, initials: 'PS', avatarBg: '#7c3aed', name: 'Priya Suresh', date: '15 May', in: '09:28', inColor: '#ea580c', out: '—', breakTime: '30m', netHours: '6h 13m', otHours: '0h', location: 'Verified', status: 'Late +28m', statusClass: 'badge-sent' },
    //     { id: 3, initials: 'RK', avatarBg: '#2563eb', name: 'Rahul Kumar', date: '14 May', in: '09:12', inColor: '#059669', out: '06:05', breakTime: '45m', netHours: '8h 53m', otHours: '0h 53m', otColor: '#2563eb', location: 'Verified', status: 'Present', statusClass: 'badge-approved' },
    //     { id: 4, initials: 'VS', avatarBg: '#dc2626', name: 'Vijay Sharma', date: '14 May', in: '—', inColor: '', out: '—', breakTime: '—', netHours: '0h', otHours: '0h', location: 'No data', locationColor: '#9ca3af', status: 'Absent', statusClass: 'badge-rejected' },
    //     { id: 5, initials: 'AM', avatarBg: '#0f766e', name: 'Arjun Menon', date: '14 May', in: '09:12', inColor: '#059669', out: '06:05', breakTime: '45m', netHours: '8h 08m', otHours: '0h', location: 'Verified', status: 'Present', statusClass: 'badge-approved' },
    // ];

    const columns = [
        {
            name: <H4>Sl.No</H4>,
            selector: row => row.si,
            sortable: true,
            center: true,
            // cell: row => <span style={{ color: '#4b5563', fontSize: '13px' }}>{row.id}</span>
        },
        {
            name: <H4>Employee</H4>,
            selector: row => row.employee_name,
            sortable: true,
            minWidth: '160px',
            wrap: true,
            // cell: row => (
            //     <div className="d-flex align-items-center">
            //         <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: row.avatarBg, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '600', marginRight: '10px', fontSize: '13px' }}>
            //             {row.initials}
            //         </div>
            //         <span style={{ fontWeight: '600', color: '#111827', fontSize: '14px' }}>{row.name}</span>
            //     </div>
            // )
        },
        {
            name: <H4>Date</H4>,
            selector: row => row.date,
            minWidth: '160px',
            warp: true,
            sortable: true,
            // cell: row => <span style={{ color: '#4b5563', fontSize: '13px' }}>{row.date}</span>
        },
        {
            name: <H4>Clock in</H4>,
            selector: row => row.checkin_time,
            minWidth: '160px',
            wrap: true,

            // cell: row => <span style={{ color: row.inColor || '#4b5563', fontWeight: '500', fontSize: '13px' }}>{row.in}</span>
        },
        {
            name: <H4>Clock out</H4>,
            selector: row => row.checkout_time,
            minWidth: '160px',
            wrap: true,
            // cell: row => <span style={{ color: '#4b5563', fontSize: '13px' }}>{row.out}</span>
        },
        {
            name: <H4>Break</H4>,
            selector: row => row.formatted_break_time,
            //  minWidth: '220px',
            wrap: true,
            // cell: row => <span style={{ color: '#4b5563', fontSize: '13px' }}>{row.breakTime}</span>
        },
        {
            name: <H4>Net hours</H4>,
            selector: row => row.formatted_hours,
            // cell: row => {
            //     const parts = row.netHours.split(' ');
            //     return (
            //         <span style={{ color: '#111827', fontSize: '13px' }}>
            //             <span style={{ fontWeight: '600' }}>{parts[0]}</span> {parts[1] && <span style={{ fontSize: '11px', color: '#6b7280' }}>{parts[1]}</span>}
            //         </span>
            //     );
            // }
        },
        {
            name: <H4>Ot hours</H4>,
            selector: row => row.otHours,

        },
        {
            name: <H4>Location</H4>,
            selector: row => row.address,
            minWidth: '220px',
            wrap: true,
            // cell: row => <span style={{ color: row.locationColor || '#059669', fontSize: '13px' }}>{row.location}</span>
        },
        {
            name: <H4>Status</H4>,
            selector: row => row.status,
            // cell: row => <span className={row.statusClass} style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '15px' }}>{row.status}</span>
        },

    ];

    const fetchStaff = async () => {
        try {
            const endpoint = authState.userRole === 1 ? getUsers : getUsersRole;
            const response = await getClientUrlDataToken(authState.apiUrl, endpoint);
            if (response.status === true) {
                const staffData = response.data || [];
                setStaffOptions(staffData.map(e => ({
                    value: e.user_id,
                    label: e.user_name
                })));
            } else {
                toast.error("Failed to load staff list");
            }
        } catch (err) {
            console.error("Error loading staff list:", err);
        }
    };

    const fetchAttendanceData = async (
        page = currentPage,
        size = perPage,
        employeeId = selectedEmployee,
        statusVal = selectedStatus,
        start = startDate,
        end = endDate,
        searchVal = ''
    ) => {
        setLoading(true);
        const endpoint = authState.userRole === 1 ? getAttendance : getAttendanceRole;
        try {
            const params = new URLSearchParams();
            params.append('page', page);
            params.append('page_length', size);
            if (employeeId) params.append('employee_id', employeeId);
            if (statusVal) params.append('status', statusVal);
            if (start) params.append('start_time', moment(start).format("YYYY-MM-DD"));
            if (end) params.append('end_time', moment(end).format("YYYY-MM-DD"));
            if (searchVal) params.append('search', searchVal);

            const response = await getClientUrlDataToken(authState.apiUrl, `${endpoint}?${params.toString()}`);
            if (response.status === true) {
                const transformedData = response.data.data.map((item, index) => ({
                    id: item.id,
                    si: (page - 1) * size + index + 1,
                    address: item.address || 'N/A',
                    checkout_time: item.checkout_time || 'N/A',
                    checkin_time: item.checkin_time || 'N/A',
                    company_id: item.company_id || 'N/A',
                    employee_id: item.employee_id || 'N/A',
                    employee_name: item.employee_name || 'N/A',
                    formatted_break_time: item.formatted_break_time || 'N/A',
                    formatted_hours: item.formatted_hours || 'N/A',
                    latitude: item.latitude || 'N/A',
                    longitude: item.longitude || 'N/A',
                    status: item.status || 'N/A',
                    total_hours: item.total_hours || 'N/A',
                    date: item.created_at || 'N/A',
                }));
                setData(transformedData);
                setTotalRows(response.data.total || 0);
            } else {
                toast.error("Failed to load attendance data");
            }
        } catch (error) {
            console.error("Error loading attendance data:", error);
            toast.error("An error occurred while loading attendance data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStaff();
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const empId = queryParams.get('employee_id') || '';
        const stat = queryParams.get('status') || '';
        const start = queryParams.get('start_time') || '';
        const end = queryParams.get('end_time') || '';
        const search = queryParams.get('search') || '';
        const page = parseInt(queryParams.get('page')) || 1;
        const pageLength = parseInt(queryParams.get('page_length')) || 10;

        setSelectedEmployee(empId);
        setSelectedStatus(stat);
        setValue('employee_id', empId);
        setValue('status', stat);
        setValue('search', search);
        setCurrentPage(page);
        setPerPage(pageLength);

        let parsedStart = null;
        let parsedEnd = null;
        if (start) parsedStart = moment(start, "YYYY-MM-DD").toDate();
        if (end) parsedEnd = moment(end, "YYYY-MM-DD").toDate();
        setDateRange([parsedStart, parsedEnd]);

        fetchAttendanceData(page, pageLength, empId, stat, parsedStart, parsedEnd, search);
    }, [location.search]);

    const handleFilterSubmit = (formData) => {
        const queryParams = new URLSearchParams();
        queryParams.set('page', '1');
        queryParams.set('page_length', String(perPage));
        if (formData.search) queryParams.set('search', formData.search);
        if (formData.employee_id) queryParams.set('employee_id', formData.employee_id);
        if (formData.status) queryParams.set('status', formData.status);
        if (startDate) queryParams.set('start_time', moment(startDate).format("YYYY-MM-DD"));
        if (endDate) queryParams.set('end_time', moment(endDate).format("YYYY-MM-DD"));

        navigate(`${location.pathname}?${queryParams.toString()}`);
    };

    const handleReset = () => {
        setValue('search', '');
        setValue('employee_id', '');
        setValue('status', '');
        setDateRange([null, null]);
        navigate(location.pathname);
    };

    const handlePageChange = (page) => {
    // Update page state and fetch data for the new page
    setCurrentPage(page);
    fetchAttendanceData(page, perPage, selectedEmployee, selectedStatus, startDate, endDate, '');
};

const handlePerRowsChange = async (newPerPage, page) => {
    // Update rows‑per‑page and page state, then fetch data
    setPerPage(newPerPage);
    setCurrentPage(page);
    fetchAttendanceData(page, newPerPage, selectedEmployee, selectedStatus, startDate, endDate, '');
};

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={'Attendance Log'} parent="Attendance" title={'Attendance Log'} />

            <div className="container-fluid">
                {/* Top Stat Cards */}
                <Card className="mb-4 shadow-sm" style={{ borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                    <CardBody className="p-0">
                        <Row className="g-0">
                            {stats.map((stat, idx) => (
                                <Col key={idx} className="text-center py-4 px-2" style={{ borderRight: idx !== stats.length - 1 ? '1px solid #e5e7eb' : 'none' }}>
                                    <h3 style={{ color: stat.valueColor, fontWeight: '700', fontSize: '26px', marginBottom: '8px', fontFamily: 'Inter, sans-serif' }}>{stat.value}</h3>
                                    <span style={{ color: '#6b7280', fontSize: '13px', fontWeight: '500' }}>{stat.title}</span>
                                </Col>
                            ))}
                        </Row>
                    </CardBody>
                </Card>

                {/* Main Content with Table and Filters */}
                <Card className="shadow-sm" style={{ borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                    {/* Filter Section */}
                    <CardHeader>
                        <H3>{'Attendance Log'}</H3>
                    </CardHeader>
                    <CardBody className="py-3 px-4" style={{ borderBottom: '1px solid #e5e7eb' }}>
                        <Form className="needs-validation" noValidate onSubmit={handleSubmit(handleFilterSubmit)}>
                            <Row className="ps-3 mb-4 align-items-center gap-2">
                                <Col sm="12" md='5' lg='2'>
                                    <input className="form-control" placeholder={Search} type="text"
                                        {...register('search')} />
                                </Col>
                                <Col sm="12" md="5" lg="3" className="form-element">
                                    <select
                                        className="form-select"
                                        {...register('employee_id')}
                                    >
                                        <option value="">Select Employee</option>
                                        {staffOptions.map((option, index) => (
                                            <option key={index} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg="2" className="form-element">
                                    <select
                                        className="form-select"
                                        {...register('status')}
                                    >
                                        <option value="">{Status}</option>
                                        <option value="Present">Present</option>
                                        <option value="Absent">Absent</option>
                                        <option value="Late">Late</option>
                                        <option value="Leave">Leave</option>
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg="3" className="form-element">
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DatePicker
                                            className="form-control digits w-100"
                                            selectsRange
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            isClearable={startDate ? true : false}
                                            monthsShown={2}
                                            popperPlacement="bottom"
                                            calendarClassName="parallel-calendar"
                                            placeholderText="Select Date Range"
                                        />
                                    </div>
                                </Col>
                                <Col sm="12" md="5" lg="2" className="d-flex gap-2 custom-filtrs">
                                    <Button type="submit">{Filter}</Button>
                                    <Button type="button" className="btn btn-light" onClick={handleReset}>Reset</Button>
                                </Col>
                            </Row>
                        </Form>

                        <div>
                            <DataTable
                                columns={columns}
                                data={data}
                                pagination
                                paginationServer
                                defaultSortAsc
                                sortServer
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                paginationTotalRows={totalRows}
                                paginationDefaultPage={currentPage}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                fixedHeader
                            />
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Fragment>
    );
};

export default AttendanceLog;